var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section-title"},[_c('span',{staticClass:"bar"}),_c('div',{staticClass:"title-text"},[_c('h3',[_vm._v(_vm._s(_vm.title))]),(_vm.subtitle)?_c('span',{staticClass:"subtitle"},[_vm._v(_vm._s(_vm.subtitle))]):_vm._e()]),(_vm.more)?_c('router-link',{staticClass:"more",attrs:{"to":_vm.more}},[_vm._v("更多 >>")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }